import { FirebaseDatabaseService } from 'modules/firebase';
import { FirebaseCollection } from 'const';

import { Location } from '../models';

export const LocationsService = new FirebaseDatabaseService<Location>(
  FirebaseCollection.Locations
);
